import { useEffect } from 'react';

function useScrollToTop() {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth' // Optional for smooth scrolling
    });
  }, []); // Empty dependency array ensures this runs only once on mount
}

export default useScrollToTop;